// extracted by mini-css-extract-plugin
module.exports = {"delimiter":"Duration_delimiter__DYUrS","title":"Duration_title__zStOm"};